import { createMuiTheme } from "@material-ui/core/styles";

const Theme = createMuiTheme({
  breakpoints: {
    values: {
      xs: 376,
      sm: 600,
      md: 940,
      lg: 1180,
      xl: 1570,
    },
  },
  palette: {
    primary: {
      main: "#F15E4E", // Red-ish color
    },
    secondary: {
      main: "#06062B", // Main black color
    },
    text: {
      primary: "#1B2636",
      secondary: "#1B2636",
    },
    colors: {
      lightGrey: "#F7F7F7",
      mediumGrey: "#E3E3E3",
      grey: "#C3C3C3",
      darkBlue: "#08052C",
      black: "#3E3E3E",
      skyBlue: "#6EBDD3",
    },
  },
  shape: {
    borderRadiusRounded: 50,
    borderRadiusMedium: 30,
    borderMedium: "1px solid #000",
    borderSmall: "0.6px solid #bdbdbd",
    borderThin: "0.2px solid #bdbdbd",
  },
  typography: {
    fontFamily: '"Ubuntu", sans-serif',
    button: {
      textTransform: "none",
    },
  },
});

export default Theme;
